import request from '@/services/request';

import {
  IPartinersFinancialWithdrawBase,
  IPartinersFinancialWithdrawPost,
  IPartnersWithdrawRequestPayload,
} from './types';

export type { IPartinersFinancialWithdrawBase, IPartinersFinancialWithdrawPost };

type GetPartnersWithdraw = (id?: number) => Promise<IPartinersFinancialWithdrawBase[]>;
export const getPartnersFinancialWithdrawRequest: GetPartnersWithdraw = async (id?: number) => {
  const { data } = await request.get(
    `/financial/partners/commissions/withdraw_request/${id ? `${id}/` : ''}`,
  );
  return data;
};

type IPostPartnerFinancialWithdraw = (
  data: IPartinersFinancialWithdrawPost | FormData,
  config?: object,
) => Promise<IPartinersFinancialWithdrawBase>;

export const postPartnersFinancialWithdrawRequest: IPostPartnerFinancialWithdraw = async (
  data,
  config,
) => {
  const { data: response } = await request.post(
    '/financial/partners/commissions/withdraw_request/',
    data,
    config,
  );
  return response;
};

export const createWithdrawRequest = async (data: IPartnersWithdrawRequestPayload) => {
  const { data: response } = await request.post('/api/v1/partners/withdraw-requests/', data);
  return response;
};

// Admin endpoints: /financial/partner-withdraw-requests/

export interface IAdminWithdrawRequest {
  id: number;
  partner: {
    id: number;
    user: {
      id: number;
      email: string;
      first_name: string;
      last_name: string;
      cpf?: string;
      cnpj?: string;
      corporate_name?: string;
      trading_name?: string;
    };
  };
  value: number;
  status: 'Pending' | 'Paid' | 'Canceled';
  date_requested: string;
  date_paid?: string;
  payment_method: string;
  cancel_reason?: string;
  created_at: string;
  signed_at?: string;
  signature_status?: string;
}

export interface IAdminWithdrawRequestDetail extends IAdminWithdrawRequest {
  bank_details: {
    id: number;
    bank: IBank;
    entity_name: string;
    branch_number: string;
    account_number: string;
    account_type: string;
    cpf: string;
    cnpj: string;
    pix_key: string;
    pix_key_type: string;
  };
  file_url?: string;
  invoice_file?: string;
}

export interface IAdminWithdrawFilters {
  page?: number;
  page_size?: number;
  date_requested_start?: string;
  date_requested_end?: string;
  partner_name?: string;
  status?: 'Pending' | 'Paid' | 'Canceled';
}

export interface IAdminWithdrawResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IAdminWithdrawRequest[];
}

export const getAdminWithdrawRequests = async (filters?: IAdminWithdrawFilters) => {
  const { data } = await request.get('/financial/partner-withdraw-requests/', { params: filters });
  return data as IAdminWithdrawResponse;
};

export const getAdminWithdrawRequestDetail = async (id: number) => {
  const { data } = await request.get(`/financial/partner-withdraw-requests/${id}/`);
  return data as IAdminWithdrawRequestDetail;
};

export const updateAdminWithdrawRequest = async (
  id: number,
  payload: { status?: string; date_paid?: string; cancel_reason?: string },
) => {
  const { data } = await request.patch(`/financial/partner-withdraw-requests/${id}/`, payload);
  return data;
};

export const exportAdminWithdrawRequests = async (filters?: IAdminWithdrawFilters) => {
  const { data } = await request.get('/financial/partner-withdraw-requests/export/', {
    params: filters,
    responseType: 'blob',
  });
  return data as Blob;
};
